import { c as _c } from "react/compiler-runtime";
import { List, StoreListingCard } from '@petsmart-ui/sparky';
import { getStoreDisplayTime, storeIsOpen } from '@libs/common-next';
import { SearchStore } from '@libs/common-types';
export type StoreListItemProps = {
  item: SearchStore;
  onClick: (storeNumber: number) => void;
  showStock?: boolean;
  isSelected?: boolean;
  isMyStore?: boolean;
};
export function StoreListItem(t0) {
  const $ = _c(51);
  const {
    item,
    onClick,
    showStock,
    isSelected,
    isMyStore
  } = t0;
  const {
    Store,
    DistanceToStoreFromOrigin,
    UnitOfDistance
  } = item;
  let T0;
  let T1;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== DistanceToStoreFromOrigin || $[1] !== Store || $[2] !== UnitOfDistance || $[3] !== isSelected || $[4] !== item.Store.StoreNumber || $[5] !== onClick || $[6] !== showStock) {
    const timezonedDate = new Date().toLocaleString("en", {
      timeZone: Store.TimeZone?.TimeZoneId
    });
    const currentDate = new Date(timezonedDate);
    T1 = List.Item;
    if ($[21] !== item.Store.StoreNumber || $[22] !== onClick) {
      t12 = () => onClick(item.Store.StoreNumber);
      $[21] = item.Store.StoreNumber;
      $[22] = onClick;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    T0 = StoreListingCard;
    t2 = `store-test-${Store.StoreNumber}`;
    if ($[24] !== Store.City || $[25] !== Store.Name || $[26] !== Store.StateProvinceAbbreviation || $[27] !== Store.StreetLine1 || $[28] !== Store.ZipPostalCode) {
      t3 = {
        addressName: Store.Name,
        street: Store.StreetLine1,
        city: Store.City,
        state: Store.StateProvinceAbbreviation,
        postalCode: Store.ZipPostalCode
      };
      $[24] = Store.City;
      $[25] = Store.Name;
      $[26] = Store.StateProvinceAbbreviation;
      $[27] = Store.StreetLine1;
      $[28] = Store.ZipPostalCode;
      $[29] = t3;
    } else {
      t3 = $[29];
    }
    t4 = Store.CurrentProductStockstatus;
    t5 = showStock;
    t6 = isSelected;
    t7 = true;
    t8 = Store.HasCurrentProductInStock;
    t9 = undefined;
    t10 = getStoreDisplayTime(Store, currentDate);
    if ($[30] !== DistanceToStoreFromOrigin || $[31] !== UnitOfDistance) {
      t11 = DistanceToStoreFromOrigin > 0 ? `${DistanceToStoreFromOrigin.toFixed(1)} ${UnitOfDistance.replace("kilometers", "kilometres")}` : undefined;
      $[30] = DistanceToStoreFromOrigin;
      $[31] = UnitOfDistance;
      $[32] = t11;
    } else {
      t11 = $[32];
    }
    t1 = storeIsOpen(Store, currentDate);
    $[0] = DistanceToStoreFromOrigin;
    $[1] = Store;
    $[2] = UnitOfDistance;
    $[3] = isSelected;
    $[4] = item.Store.StoreNumber;
    $[5] = onClick;
    $[6] = showStock;
    $[7] = T0;
    $[8] = T1;
    $[9] = t1;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    T0 = $[7];
    T1 = $[8];
    t1 = $[9];
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  const t13 = !t1;
  let t14;
  if ($[33] !== T0 || $[34] !== isMyStore || $[35] !== t10 || $[36] !== t11 || $[37] !== t13 || $[38] !== t2 || $[39] !== t3 || $[40] !== t4 || $[41] !== t5 || $[42] !== t6 || $[43] !== t7 || $[44] !== t8 || $[45] !== t9) {
    t14 = <T0 data-testid={t2} address={t3} stockStatus={t4} showStock={t5} selected={t6} hasRadio={t7} hasItems={t8} rating={t9} openText={t10} distance={t11} closed={t13} myStore={isMyStore} />;
    $[33] = T0;
    $[34] = isMyStore;
    $[35] = t10;
    $[36] = t11;
    $[37] = t13;
    $[38] = t2;
    $[39] = t3;
    $[40] = t4;
    $[41] = t5;
    $[42] = t6;
    $[43] = t7;
    $[44] = t8;
    $[45] = t9;
    $[46] = t14;
  } else {
    t14 = $[46];
  }
  let t15;
  if ($[47] !== T1 || $[48] !== t12 || $[49] !== t14) {
    t15 = <T1 onClick={t12}>{t14}</T1>;
    $[47] = T1;
    $[48] = t12;
    $[49] = t14;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  return t15;
}